import React from 'react';
import { styled, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { useLaptop } from 'hooks';

const ShippingPolicyPage = () => {
  const { isOverLaptop } = useLaptop();

  return (
    <Box>
      <Content>
        {renderTitle('Shipping Policy')}
        <br />

        {renderSubtitle('1. Delivery of Digital Products')}
        {renderText(`
          Digital Codes and Gift Cards: Once your purchase is confirmed, your digital codes or gift cards will be delivered in one of two ways:
        `)}
        {renderUl([
          'Email Delivery: The digital code or gift card will be sent to the email address provided during checkout. Delivery is typically instant but may take up to 24 hours in rare cases.',
          'Portal Delivery: You may also choose to retrieve your digital codes or gift cards through our online portal. Upon successful payment, you will be provided with a link to access your product in the portal.',
        ])}
        {renderText(`
          Please ensure that your email address is correct if you select email delivery. If you choose to retrieve your code from the portal, ensure that your login credentials are secure.
        `)}
        <br />

        {renderSubtitle('2. Non-Refundable & Non-Returnable Policy')}
        {renderText(`
          Gift Cards: All gift card purchases are final. Gift cards cannot be returned, exchanged, or refunded. Once issued, the value of the gift card is not transferable, nor can it be replaced if lost or stolen.
        `)}
        {renderText(`
          Digital Codes: Digital codes delivered via email or through the portal are also non-refundable and cannot be returned.
        `)}
        <br />

        {renderSubtitle('3. Errors and Issues with Delivery')}
        {renderText(`
          If you encounter any issues with your digital product, such as not receiving it via email or being unable to access it in the portal, please contact us immediately at help@shifa.one. We will work with you to resolve the issue as quickly as possible.
        `)}
        <br />

        {renderSubtitle('4. Order Cancellation')}
        {renderText(`
          Since our products are delivered instantly or shortly after the purchase, cancellations are generally not possible. Please ensure all order details are correct before finalizing your purchase.
        `)}
        <br />

        {renderSubtitle('5. Contact Us')}
        {renderText(`
If you have any questions, complaints, or suggestions regarding your order or our shipping policy, please feel free to reach out to us at help@shifa.one.         `)}
      </Content>
    </Box>
  );

  function renderTitle(text: string) {
    return (
      <Typography
        variant={isOverLaptop ? 'big500' : 'big700'}
        component='h1'
        mb={isOverLaptop ? 3 : 1.5}
      >
        {text}
      </Typography>
    );
  }

  function renderSubtitle(text: string) {
    return (
      <Typography variant={isOverLaptop ? 'h6' : 'h5'} component='h2' mb={1}>
        {text}
      </Typography>
    );
  }

  function renderText(text: string) {
    return (
      <Typography
        component='p'
        variant={isOverLaptop ? 'average400' : 'average200'}
      >
        {text}
      </Typography>
    );
  }

  function renderUl(texts: string[]) {
    return (
      <Typography
        component='ul'
        variant={isOverLaptop ? 'average400' : 'average200'}
        pl={0}
        sx={{ listStyle: 'inside' }}
      >
        {texts.map((text, index) => (
          <li key={index}>{text}</li>
        ))}
      </Typography>
    );
  }
};

export default ShippingPolicyPage;

export const Content = styled(Box)(({ theme }) => ({
  padding: '60px 0 80px 0',
  [theme.breakpoints.down('laptop')]: {
    padding: '24px 0 40px 0',
  },
}));
